import { useState } from "react";
import { Card, Col, FormGroup, Input, Label, Row } from "reactstrap";
import ImageUpload from "../imageUpload/ImageUpload";
import { BiSolidTrash } from "react-icons/bi";
import NotesCard from "./NotesCard";
import { uniqueID } from "../../firebase/utility";

const QuoteItemCard = ({ data, index, line_items, setLineItems }) => {
  const [product, setProduct] = useState(data);
  //GENERAL STATES
  const [formData, setFormData] = useState({
    parts: product?.sku?.slice(4, product.sku.length),
    price: product?.price ?? 0,
    description: product?.item_title || product?.name || product?.description || "",
    sku: product?.sku ?? "",
    quantity: product?.quantity ?? 0,
    exUnitPrice: product?.exUnitPrice ?? 0,
    image: { id: product?.image?.id ?? "", src: product?.image?.src ?? "" },
  });
  const handleChange = (key, value) => {
    let data;
    if (key === "image") {
      data = { ...formData, [key]: { src: value, id: uniqueID() } };
      setFormData(data);
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [key]: value,
      }));
    }
    const newData = line_items?.map((item, idx) => {
      if (idx === index) {
        if (key === "image") {
          return {
            ...item,
            ...data,
          };
        } else {
          return {
            ...item,
            [key]: value,
          };
        }
      }
      return item;
    });
    setLineItems(newData);
  };
  const deleteItem = (product) => {
    var localItems = [...line_items];
    localItems = localItems?.filter((i, index) => i?._id !== product);
    setLineItems(localItems);
  };
  return (
    <>
      <Card className="shadow border-0 mb-3 py-3">
        <Row className="mx-0 mx-lg-2">
          <Col md={1}>
            <div>
              <ImageUpload
                index={index}
                itemImage={formData?.image?.src}
                handleImageUpload={handleChange}
              />
              <div className="text-center">
                <BiSolidTrash
                  style={{ color: "red" }}
                  size={30}
                  className="my-3"
                  onClick={() => {
                    deleteItem(product?._id);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md={2}>
            <FormGroup floating>
              <Input
                type={"text"}
                placeholder={"Part"}
                value={formData.parts}
                onChange={(e) => handleChange("parts", e.target.value)}
                className={"border border-1"}
                disabled
              />
              <Label className="mb-1 fw-bold">Part #</Label>
            </FormGroup>
            <FormGroup floating>
              <Input
                type={"text"}
                placeholder={"Sku"}
                value={formData.sku}
                onChange={(e) => handleChange("sku", e.target.value)}
                className={"border border-1"}
              />
              <Label className="mb-1 fw-bold">Sku</Label>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup floating>
              <NotesCard
                height={"120px"}
                type={"textarea"}
                className={"bg-secondary-color border-1"}
                placeholder={"Item Title"}
                value={formData.description}
                handleChange={(e) =>
                  handleChange("description", e.target.value)
                }
              />
              <Label className="mb-1 fw-bold">Item Title</Label>
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup floating>
              <Input
                type={"number"}
                placeholder={"$22"}
                className={"border border-1"}
                value={formData.quantity}
                onChange={(e) => handleChange("quantity", e.target.value)}
              />
              <Label className="mb-1 fw-bold">Quantity</Label>
            </FormGroup>
            <FormGroup floating>
              <Input
                type={"text"}
                placeholder={"$22"}
                className={"border border-1"}
                value={(formData?.price * formData?.quantity).toFixed(2)}
                readOnly={true}
              />
              <Label className="mb-2 fw-bold">Ext Price</Label>
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup floating>
              <Input
                type={"number"}
                placeholder={"Unit Price"}
                className={"border border-1"}
                value={formData.price}
                onChange={(e) => handleChange("price", e.target.value)}
              />
              <Label className="mb-1 fw-bold">Unit Price</Label>
            </FormGroup>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default QuoteItemCard;
